import { useInfiniteQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { getAnnouncementActivity } from '../../../api/announcements.api';
import { queryKeys } from '../../../api/queryKeys';

const PAGE_SIZE = 10;

/**
 * The feed of views and dismissals, newest first, a page at a time behind
 * "Show more". An empty page is the end, but a short one already says so -
 * which spares the click that would only fetch nothing.
 */
export const useAnnouncementActivity = (id: number) => {
  const query = useInfiniteQuery({
    queryKey: queryKeys.admin.announcements.activity(id),
    queryFn: async ({ pageParam }) => {
      const { data } = await getAnnouncementActivity(id, {
        page: pageParam,
        limit: PAGE_SIZE,
      });
      return data.data ?? [];
    },
    initialPageParam: 1,
    getNextPageParam: (last, pages) =>
      last.length === PAGE_SIZE ? pages.length + 1 : undefined,
  });

  const events = useMemo(() => query.data?.pages.flat() ?? [], [query.data]);

  return {
    events,
    isLoading: query.isLoading,
    hasNextPage: query.hasNextPage,
    isFetchingNextPage: query.isFetchingNextPage,
    fetchNextPage: query.fetchNextPage,
  };
};
